import React, { useState } from "react";
import "../Services/Services.css";

const ITEMS_PER_VIEW = 3;

const OurGalleryPreview = ({ previewService, setShowPreviewOurGallery }) => {
    const [startIndex, setStartIndex] = useState(0);

    if (!previewService || !previewService.videoTestimonials?.length) {
        return null;
    }

    const { title, heading, description, videoTestimonials } = previewService;
    const images = videoTestimonials;

    const handleNext = () => {
        if (startIndex + ITEMS_PER_VIEW < images.length) {
            setStartIndex(startIndex + 1);
        }
    };

    const handlePrev = () => {
        if (startIndex > 0) {
            setStartIndex(startIndex - 1);
        }
    };

    const visibleImages = images.slice(
        startIndex,
        startIndex + ITEMS_PER_VIEW
    );

    return (
        <div className="og-overlay" onClick={() => setShowPreviewOurGallery(false)}>
            <div className="og-modal" onClick={(e) => e.stopPropagation()}>

                
                <button className="og-close" onClick={() => setShowPreviewOurGallery(false)}>
                    ✕
                </button>

                <div className="og-header">
                    <span className="og-subtitle">{title}</span>
                    <h2>{heading}</h2>

                    <div
                        className="og-description"
                        dangerouslySetInnerHTML={{ __html: description }}
                    />
                </div>
              
                <div className="og-gallery-wrapper">

                    {images.length > ITEMS_PER_VIEW && (
                        <button
                            className="og-arrow left"
                            onClick={handlePrev}
                            disabled={startIndex === 0}
                        >
                            ‹
                        </button>
                    )}

                    <div className="og-gallery">
                        {visibleImages.map((item, index) => (
                            <div className="og-card" key={index}>
                                <img
                                    src={item.videos}
                                    alt="Gallery"
                                />
                            </div>
                        ))}
                    </div>

                    {images.length > ITEMS_PER_VIEW && (
                        <button
                            className="og-arrow right"
                            onClick={handleNext}
                            disabled={startIndex + ITEMS_PER_VIEW >= images.length}
                        >
                            ›
                        </button>
                    )}

                </div>
            </div>
        </div>
    );
};

export default OurGalleryPreview;
